import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private _selectedLanguage: string = '';

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService
  ) {
    this._selectedLanguage = translate.currentLang;
  }

  public get languages() {
    return this.translate.getLangs();
  }

  public get currentLang() {
    return this.translate.currentLang;
  }

  public get selectedLanguage() {
    return this._selectedLanguage;
  }

  public set selectedLanguage(value: string) {
    this._selectedLanguage = value;
    this.translate.use(this._selectedLanguage);
    this.cookieService.put('lang', this._selectedLanguage, {
      sameSite: 'strict',
      secure: window.location.protocol === 'https:',
    });
  }

  public initLanguage() {
    this.translate.addLangs(['ENG', 'HUN']);
    this.translate.setDefaultLang('ENG');
    const language = this.cookieService.get('lang');
    this.selectedLanguage = language ?? this.translate.getDefaultLang();
  }
}
